/**
 * @copyright © 2015, Rick Wong. All rights reserved.
 */
"use strict";

module.exports = {
	Promise: global.Promise || function () {
		throw new Error("Missing ES6 Promise implementation");
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/react-transmit/src/lib/promiseProxy.js
// module id = 231
// module chunks = 0